import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { goBack, push } from 'react-router-redux'

import {
  clearChecklistErrors,
  readChecklist,
  setChecklistErrors,
  setChecklistProject,
  updateChecklist,
} from '../actions/checklist'

import ChecklistEdit from '../components/ChecklistEdit'

class ChecklistEditPage extends Component {
  componentDidMount () {
    const { clearChecklistErrors, readChecklist, match } = this.props
    clearChecklistErrors()
    readChecklist(match.params.id)
  }

  render () {
    return (<ChecklistEdit {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { current, project, projectVersion } = state.checklist
  const props = {
    errors: state.checklist.errors || {},
    project: project ? { ...project } : undefined,
    projectVersion,
  }
  if (current && project) {
    const initialValues = {
      checklistId: current.id,
    }
    _.forEach(current.list, (mainArea => {
      _.forEach(mainArea.defectAreas, (defectArea => {
        initialValues[`defectArea-${defectArea.defectAreaId}`] = 'true'
      }))
    }))
    _.forEach(project.mainAreas, (mainArea => {
      _.forEach(mainArea.defectAreas, (defectArea => {
        if (!initialValues[`defectArea-${defectArea.id}`]) {
          initialValues[`defectArea-${defectArea.id}`] = 'false'
        }
      }))
    }))
    props.initialValues = initialValues
    if (projectVersion === 1) {
      const { mainAreas } = props.project
      _.forEach(current.list, ((mainArea, i) => {
        _.forEach(mainAreas, ((pMainArea, pI) => {
          if (pMainArea.id === mainArea.mainAreaId) {
            const mTemp = mainAreas[i]
            mainAreas[i] = mainAreas[pI]
            mainAreas[pI] = mTemp
            const { defectAreas } = pMainArea
            _.forEach(mainArea.defectAreas, ((defectArea, j) => {
              _.forEach(defectAreas, ((pDefectArea, pJ) => {
                if (pDefectArea.id === defectArea.defectAreaId) {
                  const dTemp = defectAreas[j]
                  defectAreas[j] = defectAreas[pJ]
                  defectAreas[pJ] = dTemp
                  return false
                }
              }))
            }))
            return false
          }
        }))
      }))
    }
  }
  return props
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onSubmit (id, project, values) {
    const errors = {}
    const data = {
      id,
      projectId: project.id,
      list: []
    }
    _.forEach(project.mainAreas, (mainArea) => {
      const defectAreas = []
      _.forEach(mainArea.defectAreas, (defectArea) => {
        const key = `defectArea-${defectArea.id}`
        if (values[key] && values[key] === 'true') {
          defectAreas.push({ defectAreaId: defectArea.id })
        }
      })
      if (defectAreas.length > 0) {
        data.list.push({ mainAreaId: mainArea.id, defectAreas })
      }
    })
    if (data.list.length === 0) {
      errors.list = 'Must select at least one defect area.'
    }
    if (!_.isEmpty(errors)) {
      dispatch(setChecklistErrors(errors))
      return
    }
    dispatch(clearChecklistErrors())
    await dispatch(updateChecklist(data))
    dispatch(push('/checklist'))
  },
  readChecklist (id) {
    dispatch(readChecklist(id, true))
  },
  clearChecklistErrors () {
    dispatch(clearChecklistErrors())
  },
  changeMainAreaOrder (project, index, up) {
    const newIndex = up ? index - 1 : index + 1
    const temp = project.mainAreas[newIndex]
    project.mainAreas[newIndex] = project.mainAreas[index]
    project.mainAreas[index] = temp
    dispatch(setChecklistProject(project))
  },
  changeDefectAreaOrder (project, mainAreaIndex, index, up) {
    const { defectAreas } = project.mainAreas[mainAreaIndex]
    const newIndex = up ? index - 1 : index + 1
    const temp = defectAreas[newIndex]
    defectAreas[newIndex] = defectAreas[index]
    defectAreas[index] = temp
    project.mainAreas[mainAreaIndex].defectAreas = defectAreas
    dispatch(setChecklistProject(project))
  },
  goBack () {
    dispatch(goBack())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistEditPage)


// WEBPACK FOOTER //
// ./src/containers/ChecklistEditPage.js